<template>
  <div id="teamup-layout" :class="{ 'safe-bottom': safeBottom }">
    <template v-if="offLine">
      <div class="offline-page">
        <fps-header class="offline-title" :backColor="hideBack ? '' : 'black'" />
        <div class="offline-body">
          <img src="~/assets/image/offline.png" />
          <p class="title">{{ $t('skill_Whoops') }}</p>
          <p class="desc">{{ $t('skill_Noconnection') }}</p>
          <van-button @click="pageReload">{{ $t('skill_tryAgain') }}</van-button>
        </div>
      </div>
    </template>
    <template v-else-if="requestError">
      <div class="offline-page">
        <fps-header class="offline-title" :backColor="hideBack ? '' : 'black'" />
        <div class="offline-body">
          <img src="~/assets/image/offline.png" />
          <p class="title">{{ $t('skill_Whoops') }}</p>
          <p class="desc">{{ $t('h5_request_error') }}</p>
          <van-button @click="pageReload">{{ $t('skill_tryAgain') }}</van-button>
        </div>
      </div>
    </template>
    <template v-else>
      <slot />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    // 是否處理底部安全距離（iPhoneX）
    safeBottom: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['offLine', 'routesHistory','requestError']),
    hideBack() {
      // 隱藏無網狀態下的返回按鈕
      return this.offLine && this.routesHistory.length < 2
    }
  },
  created() {
    const isOffline = navigator && typeof navigator.onLine === 'boolean' && !navigator.onLine
    this.setOffline(!!isOffline)
  },
  methods: {
    ...mapActions('app', ['setOffline']),
    pageReload() {
      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
  #teamup-layout {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: var(--nc-text-primary, $color-gray-1);
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
    height: 100vh;
    background: var(--nc-bg-page, #fff);
    > div {
      position: absolute;
      left: 0;
      top: 0;
      width: 100vw;
      min-height: 100vh;
      -webkit-overflow-scrolling: touch;
    }
    &.safe-bottom {
      > div {
        @include safeBottom;
      }
    }
  }

  .offline {
    &-page {
      @include flex(center, center, column);
      align-items: center;
      height: 100vh;
      overflow: hidden;
    }
    &-title {
      flex-grow: 0;
      flex-shrink: 0;
    }
    &-body {
      flex-grow: 1;
      @include flex(flex-start, center, column);
      padding: 0 134px;
      img {
        width: 230px;
        height: 230px;
        margin-top: 180px;
      }
      .title {
        color: var(--nc-text-primary, $color-gray-1);
        font-size: 36px;
        margin-top: 60px;
        font-weight: 600;
      }
      .desc {
        color: var(--nc-text-secondary, $color-gray-2);
        margin-top: 28px;
        font-size: 28px;
        line-height: 40px;
      }
      button {
        width: 440px;
        height: 100px;
        margin: 74px auto;
        color: $color-button-text;
        font-size: 32px;
        font-weight: 600;
        border-radius: 60px;
        background: $color-yellow;
      }
    }
  }
</style>
